import moment from 'moment/moment';

export const dateTimeFormattingByString = (stringDate) => {
  const date = stringDate ? new Date(stringDate) : null;
  return dateTimeFormattingByDate(date);
};

export const dateTimeFormattingByDate = (date) =>
  date ? `${timeFormattingByDate(date)} ${dateFormattingByDate(date)}` : null;

export const dateFormattingByString = (stringDate, showDay) => {
  const date = stringDate ? new Date(stringDate) : null;
  return dateFormattingByDate(date, showDay);
};

export const timeFormattingByString = (stringDate) => {
  const date = stringDate ? new Date(stringDate) : null;
  return timeFormattingByDate(date);
};

export const timeFormattingByDate = (date) =>
  date
    ? date
        .toLocaleString('uk-UA', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        })
        .toString()
    : null;
export const dateFormattingByDateShort = (date, showDay = true, monthType = 'numeric') =>
  date
    ? date
        .toLocaleString('uk-UA', {
          ...(showDay && { day: 'numeric' }),
          month: monthType,
          year: 'numeric'
        })
        .toString()
        .replace(/\./g, '/')
    : null;
export const dateFormattingByDateDot = (date, showDay = true, monthType = 'numeric') =>
  date
    ? date
        .toLocaleString('uk-UA', {
          ...(showDay && { day: 'numeric' }),
          month: monthType,
          year: 'numeric'
        })
        .toString()
        .replace(/\./g, '.')
    : null;
export const dateFormattingByDateDotTime = (date, showDay = true, monthType = 'numeric') =>
  date
    ? date
        .toLocaleString('uk-UA', {
          ...(showDay && { day: 'numeric' }),
          month: monthType,
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        })
        .toString()
        .replace(/\./g, '.')
        .replace(/,./g, ' ')
    : null;
export const dateFormattingByDate = (date, showDay = true, monthType = 'long') =>
  date
    ? date
        .toLocaleString('uk-UA', {
          ...(showDay && { day: 'numeric' }),
          month: monthType,
          year: 'numeric'
        })
        .toString()
    : null;
export const monthFormattingByDate = (date, showDay = true) =>
  date
    ? date
        .toLocaleString('uk-UA', {
          month: 'numeric'
        })
        .toString()
    : null;
export const yearFormattingByDate = (date, showDay = true) =>
  date
    ? date
        .toLocaleString('uk-UA', {
          year: 'numeric'
        })
        .toString()
    : null;
export const timeDiff = (date) => {
  let diffTime = Math.abs(new Date().valueOf() - new Date(date).valueOf());
  let days = diffTime / (24 * 60 * 60 * 1000);
  let hours = (days % 1) * 24;
  let minutes = (hours % 1) * 60;

  [days, hours, minutes] = [Math.floor(days), Math.floor(hours), Math.floor(minutes)];
  if (days !== 0) {
    return `${days} дн тому`;
  } else if (days === 0 && hours !== 0) {
    return `${hours} год тому`;
  } else if (days === 0 && hours === 0) {
    return `${minutes} хв тому`;
  }
};
export const timeDiffChat = (date, message = false) => {
  let diffTime = Math.abs(new Date().valueOf() - new Date(date).valueOf());
  let days = diffTime / (24 * 60 * 60 * 1000);
  let hours = (days % 1) * 24;
  let minutes = (hours % 1) * 60;

  [days, hours, minutes] = [Math.floor(days), Math.floor(hours), Math.floor(minutes)];

  if (days === 1) {
    return `вчора`;
  } else if (days > 1 && !message) {
    return `${dateFormattingByDate(new Date(date), true, 'numeric')}`;
  } else if (days > 1 && message) {
    return `${timeFormattingByDate(new Date(date))}`;
  } else if (days === 0 && hours === 0 && minutes <= 1) {
    return `щойно`;
  } else if (days === 0 && hours === 0 && minutes > 1) {
    return `${timeFormattingByDate(new Date(date))}`;
  } else if (days === 0 && hours !== 0) {
    return `${timeFormattingByDate(new Date(date))}`;
  }
};
export const timeDiffNotif = (date, message = false) => {
  let diffTime = Math.abs(new Date().valueOf() - new Date(date).valueOf());
  let days = diffTime / (24 * 60 * 60 * 1000);
  let hours = (days % 1) * 24;
  let minutes = (hours % 1) * 60;
  [days, hours, minutes] = [+days.toFixed(), +hours.toFixed(), +minutes.toFixed()];

  if (days === 1) {
    return `вчора`;
  } else if (days > 1 && !message) {
    return `${dateFormattingByDate(new Date(date), true, 'numeric')}`;
  } else if (days > 1 && message) {
    return `${timeFormattingByDate(new Date(date))}`;
  } else if (days === 0 && hours === 0 && minutes <= 1) {
    return `щойно`;
  } else if (days === 0 && hours === 0 && minutes > 1) {
    return `${timeFormattingByDate(new Date(date))}`;
  } else if (days === 0 && hours !== 0) {
    return `${timeFormattingByDate(new Date(date))}`;
  }
};
export const timeDiffMessages = (date) => {
  let diffTime = Math.abs(new Date().valueOf() - new Date(date).valueOf());
  let days = diffTime / (24 * 60 * 60 * 1000);
  let hours = (days % 1) * 24;
  let minutes = (hours % 1) * 60;

  [days, hours, minutes] = [Math.floor(days), Math.floor(hours), Math.floor(minutes)];

  if (days === 1) {
    return `вчора`;
  } else if (days > 1) {
    return `${dateFormattingByDate(new Date(date), true, 'numeric')}`;
  }
};
export const timeDiffMessagesDay = (date) => {
  var formats = {
    lastWeek: 'DD.MM.YYYY',
    lastDay: '[Вчора]',
    sameDay: '[Сьогодні]',
    nextDay: '[Tomorrow]',
    nextWeek: 'dddd',
    sameElse: 'DD.MM.YYYY'
  };
  // var formatedDate = date;

  var output = moment(date).calendar(null, formats);

  return output;
};
export const monthHandler = (month, type = 'month') => {
  if (type === 'month') {
    switch (month) {
      case 1:
        return 'Січня';
      case 2:
        return 'Лютого';
      case 3:
        return 'Березня';
      case 4:
        return 'Квітня';
      case 5:
        return 'Травня';
      case 6:
        return 'Червня';
      case 7:
        return 'Липня';
      case 8:
        return 'Серпня';
      case 9:
        return 'Вересня';
      case 10:
        return 'Жовтня';
      case 11:
        return 'Листопада';
      case 12:
        return 'Грудня';
      default:
        return;
    }
  } else {
    switch (month) {
      case 1:
        return 'Січ';
      case 2:
        return 'Лют';
      case 3:
        return 'Бер';
      case 4:
        return 'Кві';
      case 5:
        return 'Тра';
      case 6:
        return 'Чер';
      case 7:
        return 'Лип';
      case 8:
        return 'Сер';
      case 9:
        return 'Вер';
      case 10:
        return 'Жов';
      case 11:
        return 'Лис';
      case 12:
        return 'Гру';
      default:
        return;
    }
  }
};
